import React, { useEffect, useState } from 'react';
import Header from '../../Components/Header';
import { FaSearch } from "react-icons/fa";
import MaterialTable from '../../Components/Table/MaterialTable';
import { tableEye } from '../../common/Assets/imgs';
import { useNavigate } from 'react-router-dom';
import { URLS } from '../../Services/Constant';
import { get, post} from '../../Services/ApiHandler';
import toast from 'react-hot-toast';

const Roles = () => {

    const navigation = useNavigate();
    const [search,setSearch]=useState("");
    const [pagination, setPagination] = useState(1);
    const [loader, setLoader] = useState(false);

    const [adminList,setAdminList] = useState([]);
        // {
        //     sno: "01",
        //     adminId: "KD075821",
        //     adminName: "Vikram",
        //     role: "Admin",
        //     mobile: "+91 8965346856",
        //     status: "Active",
        // },
        // {
        //     sno: "02",
        //     adminId: "KD075822",
        //     adminName: "Surya",
        //     role: "Super Admin",
        //     mobile: "+91 8965346856",
        //     status: "Active",
        // },
        // {
        //     sno: "03",
        //     adminId: "KD075823",
        //     adminName: "Ajay",
        //     role: "Sub Admin",
        //     mobile: "+91 8965346856",
        //     status: "De-Active",
        // },
    // ];

    const pageSize = 10;
    const columns = [
        // {
        //     accessorKey: "sno",
        //     header: "S.No",
        // },
          {
      header: "S.No",
    //   accessorFn: (row, index) => index + 1,
         accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
      id: "serial_no",
    },
        {
            accessorKey: "name",
            header: "Role",
        },
        {
            accessorKey: "status",
            header: "Status",
            Cell: ({ cell,row }) => {
                const value = cell.getValue();
                return (
                    <span className={`${cell.getValue() ? "status-active" : "status-inactive"}`}
                     onClick={()=>statusChanger(row?.original?.id,row?.original?.status)}
                    >
                  {cell.getValue() ? "Active" : "inactive"}
                    </span>
                );
            },
        },
        {
            id: "action", // ✅ important when no accessorKey
            header: "Action",
            Cell: ({ row }) => (
                <div onClick={() => 
                    navigation('/add-roles',{
                   state: { 
                    data: row.original,
                     type: "view" },  
                })}
                >
                    <img src={tableEye} alt="" className='tableeye' />
                </div>
            ),
        },
    ];

      const statusChanger = (id, currentStatus) => {
    post(`${URLS.ROLES_LIST}${id}/`, {
      status: currentStatus === true ? false : true,
    })
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message);
          getList(search,pagination); // refresh table
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };


    const getList = async(src,page) =>{
     try {
        setLoader(true);
        const res = await get(`${URLS.ROLES_LIST}?search=${src}&page=${page}`)
        console.log("res",res);
        if(res?.status === "success"){
            setAdminList(res?.data)
            setLoader(false);
        }
     }
     catch(err){
        console.log('err',err); 
        setLoader(false);       
     }
    }

    useEffect(()=>{
     getList(search,pagination);
    },[search,pagination])


    return (
        <div>
            <Header title={"Roles"}/>

            <div className="container-fluid main-container">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                    {/* LEFT TITLE */}
                    <h3 className="m-0 fw-bold fs-5 text-black">Roles</h3>

                    {/* RIGHT SECTION */}
                    <div className="d-flex align-items-center gap-3">

                        {/* SEARCH BOX */}
                        <div className="search-box d-flex align-items-center px-3">
                            <input
                                type="text"
                                placeholder="Search"
                                className="border-0 outline-none bg-transparent"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <div className="ms-2 searchdote" >|</div>
                            <FaSearch color='#7A52AB' className="ms-1" />
                        </div>

                        {/* ADD BUTTON */}
                        <button onClick={() => navigation('/add-roles',
                            {state: {type: "add"} }
                        )} style={{ backgroundColor: "#F98425" }} className="btn text-white fw-semibold px-4 py-2">
                            + Add Roles
                        </button>

                    </div>

                </div>
                <MaterialTable columns={columns} data={adminList || []} 
                pagination={pagination}
                 setPagination={setPagination}
                 loading={loader}
                />
            </div>
        </div>
    );
};

export default Roles;
